// extracted by mini-css-extract-plugin
export default {"overview_item":"DayOverview_overview_item__DRgKh","item_value":"DayOverview_item_value__jlHlf","overflow":"DayOverview_overflow__mwpmV","error":"DayOverview_error__-lTxH"};